export default function Editorial(){
    return(
        <div className="editorial">
            <div className="nnc"></div>
            <div className="main">
                <h1 className="head">Coming Soon</h1>
                <h2 className="description">Bringing Fresh Soap Tips to you!</h2>
            </div>
        </div>
    )
}